import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'device-catalog',
  children: {
    variantId: {
      path: ':variantId',
    },
    orderPlan: {
      path: 'order-plan',
    },
    orderPlanSubmitted: {
      path: 'order-plan/submitted',
    },
    orders: {
      path: 'orders',
    },
  },
} as const satisfies Location
